import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { FetchApi } from "../../Api/AuthenticatedApi";

// Loads an org's record types for an entity ("contact" | "company") and surfaces
// the default type's id (for pre-selecting on new records).
export default function useRecordTypes(entityType) {
  const { getAccessTokenSilently } = useAuth0();
  const [types, setTypes] = React.useState([]);

  React.useEffect(() => {
    FetchApi(getAccessTokenSilently, "/api/record-types/?entity_type=" + entityType,
      (data) => setTypes(data || []), () => {}, () => {});
  }, [getAccessTokenSilently, entityType]);

  const defaultType = types.find((t) => t.is_default);
  return { types, defaultTypeId: (defaultType && defaultType.id) || "" };
}
